import React from 'react';
import LivePreview from './LivePreview/index';

const LivePreviewWrapper = () => {
  return <LivePreview />;
};

export default LivePreviewWrapper; 